module.exports = __webpack_public_path__ + "static/media/brasil-cores-da-vida.6718b1cd.png";